var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "work-list-item",
      class: { "work-list-item--masked": _vm.isScriptModeMasked },
      attrs: {
        type: "button",
        disabled: _vm.disabled,
        "aria-disabled": _vm.isScriptModeMasked,
      },
      on: {
        click: function ($event) {
          return _vm.$emit("select")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "work-list-item__cover" },
        [
          _c("image-view", {
            key: _vm.coverImageVersion,
            staticClass: "work-list-item__image",
            attrs: {
              src: _vm.imageSrc,
              placeholder: "/img/placeholders/novel.png",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "work-list-item__info" }, [
        _c("span", { staticClass: "work-list-item__title" }, [
          _vm._v(_vm._s(_vm.novel.title)),
        ]),
        _c("div", { staticClass: "work-list-item__meta" }, [
          _vm.workStatusLabel
            ? _c("span", { staticClass: "work-list-item__status" }, [
                _vm._v(_vm._s(_vm.workStatusLabel)),
              ])
            : _vm._e(),
          _c(
            "span",
            { staticClass: "work-list-item__date" },
            [
              _c("icon-pencil", { staticClass: "work-list-item__date-icon" }),
              _vm._v(" " + _vm._s(_vm.createdAtLabel) + " "),
            ],
            1
          ),
          _c(
            "span",
            { staticClass: "work-list-item__date" },
            [
              _c("icon-reload", { staticClass: "work-list-item__date-icon" }),
              _vm._v(" " + _vm._s(_vm.updatedAtLabel) + " "),
            ],
            1
          ),
        ]),
        _vm.novel.groups && _vm.novel.groups.length > 0
          ? _c(
              "div",
              { staticClass: "work-list-item__groups" },
              _vm._l(_vm.novel.groups, function (group) {
                return _c(
                  "span",
                  { key: group.groupId, staticClass: "work-list-item__group" },
                  [
                    _c("icon-folder-heart", {
                      staticClass: "work-list-item__group-icon",
                    }),
                    _vm._v(" " + _vm._s(group.name) + " "),
                  ],
                  1
                )
              }),
              0
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }